import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import './AboutPartner.css';

export default function AboutPartner() {
  const cardRefs = useScrollReveal(3);

  return (
    <section className="about-partner" id="about-partner">
      <div className="about-partner-container">
        
        <header className="about-partner-header">
          <h2>Official Canadian Playermaker Partner</h2>
          <p>
            iLOVEthisgame.ca is proud to be an authorized, official retail and distribution partner for Playermaker 
            in Canada. We are dedicated to providing Canadian soccer players, youth athletes, competitive clubs, and elite 
            academies across all provinces with state-of-the-art boot-mounted wearable tracking technology without the complexity 
            or hidden costs of international cross-border shipping and import tariffs.
          </p>
        </header>

        <article className="about-partner-content">
          <div className="partner-benefit-card" ref={(el) => (cardRefs.current[0] = el)}>
            <h3><span className="highlight-text">Lifetime</span> Warranty with Active Subscription</h3>
            <p>
              When you purchase directly from iLOVEthisgame.ca, your Playermaker 2.0 Smart Soccer Tracker is fully covered by a 
              comprehensive lifetime manufacturer warranty with an active subscription. You deal directly with our Canadian support team 
              for seamless replacements, troubleshooting, and rapid warranty service.
            </p>
          </div>

          <div className="partner-benefit-card" ref={(el) => (cardRefs.current[1] = el)}>
            <h3>Fast, Local Canadian <span className="highlight-text">Fulfillment</span></h3>
            <p>
              Avoid unpredictable customs delays, expensive duty charges, and currency conversion fees. All Playermaker 2.0 
              smart tracker kits ship rapidly from our Canadian fulfillment centers in Canadian dollars (CAD), ensuring your gear 
              arrives on the pitch faster and hassle-free.
            </p>
          </div>

          <div className="partner-benefit-card" ref={(el) => (cardRefs.current[2] = el)}>
            <h3>Localized Expert <span className="highlight-text">Support</span></h3>
            <p>
              As the official Canadian distribution partner, our team understands the unique structure of Canadian soccer, 
              from grassroots youth development and provincial leagues up to the Canadian Premier League (CPL) and national team pathways. 
              We provide responsive, localized customer support tailored specifically for Canadian athletes and coaches.
            </p>
          </div>
        </article>

      </div>
    </section>
  );
}
